import { useEffect, useState } from 'react';
import { listBusinessRole } from 'services/Settings';
import { totalCountEvent } from 'services/generalServices';

export function useBusinessRole(practice_area = '', loadFullList = true, limit = 15, isLandingPage = false) {
  const [List, setList] = useState([]);
  const [nextToken, setNextToken] = useState('');

  const loadBusinessRoles = async () => {
    let pageLimit = limit;
    if (loadFullList) {
      const response = await totalCountEvent('business_role');
      pageLimit = response?.data;
    }
    try {
      const response = await listBusinessRole(pageLimit, '', 'forward', false, '', practice_area);
      setList(response?.data?.business_role);
      setNextToken(response?.data?.next_token || '');
      return response?.data;
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    loadBusinessRoles();
  }, [practice_area]);

  return { businessRoleList: List };
}
